import { keys, map } from 'lodash';
import { FilterOperation } from '../../components/Grid/dataProvider';

const createItems = obj => map(keys(obj), e => ({ id: e, label: obj[e] }));

export const ReleasedType = createItems({
  RELEASED: 'Uvolněný',
  NOT_RELEASED: 'Neuvolněný',
});

export const RealtyType = createItems({
  ATELIER: 'ateliér',
  BUDOVA_BEZ_CISLA: 'budova bez čísla popisného nebo evidenčního',
  BUDOVA_S_EVIDENCNIM: 'budova s číslem evidenčním',
  BUDOVA_S_POPISNYM: 'budova s číslem popisným',
  BUDOVA_ROZESTAVENE_JEDNOTKY: 'budova s rozestavěnými jednotkami',
  BYT: 'byt',
  CHMELNICE: 'chmelnice',
  DILNA: 'dílna nebo provozovna',
  GARAZ_JEDNOTKA: 'garáž',
  OTHER: 'jiné',
  NEBYT: 'jiný nebytový prostor',
  LESNI_POZEMEK: 'lesní pozemek',
  ZAHRANICI: 'nemovitost v zahraničí',
  ORNA_PUDA: 'orná půda',
  OSTATNI_PLOCHA: 'ostatní plocha',
  OVOCNY_SAD: 'ovocný sad',
  PRAVO_STAVBY: 'právo stavby',
  BUDOVA_ROZESTAVENA: 'rozestavěná budova',
  ROZESTAVENA_JEDNOTKA: 'rozestavěná jednotka',
  SKUPINA_BYTU: 'skupina bytů',
  SKUPINA_OBOJE: 'skupina bytů a nebytových prostorů',
  SKUPINA_NEBYTU: 'skupina nebytových prostorů',
  TRAVNATY_POROST: 'trvalý travní porost',
  VINICE: 'vinice',
  VODNI_DILO: 'vodní dílo',
  VODNI_PLOCHA: 'vodní plocha',
  ZAHRADA: 'zahrada',
  ZASTAVENA_PLOCHA: 'zastavěná plocha a nádvoří'
});

export const RealtyTypeSelect = createItems({
  JEDNOTKA: 'jednotka',
  OTHER: 'jiné (např. nemovitost v zahraničí)',
  POZEMEK: 'pozemek',
  PRAVO_STAVBY: 'právo stavby',
  STAVBA: 'stavba'
});

export const RealtyTypeSelectRaw = {
  JEDNOTKA: 'JEDNOTKA',
  POZEMEK: 'POZEMEK',
  PRAVO_STAVBY: 'PRAVO_STAVBY',
  STAVBA: 'STAVBA',
  OTHER: 'OTHER',
};

export const RealtyTypeFilters = {
  POZEMEK: {
    ZAHRADA: 'ZAHRADA',
    LESNI_POZEMEK: 'LESNI_POZEMEK',
    CHMELNICE: 'CHMELNICE',
    TRAVNATY_POROST: 'TRAVNATY_POROST',
    ZASTAVENA_PLOCHA: 'ZASTAVENA_PLOCHA',
    ORNA_PUDA: 'ORNA_PUDA',
    OVOCNY_SAD: 'OVOCNY_SAD',
    VODNI_PLOCHA: 'VODNI_PLOCHA',
    VINICE: 'VINICE',
    OSTATNI_PLOCHA: 'OSTATNI_PLOCHA',
  },
  STAVBA: {
    BUDOVA_S_POPISNYM: 'BUDOVA_S_POPISNYM',
    BUDOVA_S_EVIDENCNIM: 'BUDOVA_S_EVIDENCNIM',
    BUDOVA_BEZ_CISLA: 'BUDOVA_BEZ_CISLA',
    BUDOVA_ROZESTAVENA: 'BUDOVA_ROZESTAVENA',
    VODNI_DILO: 'VODNI_DILO',
    BUDOVA_ROZESTAVENE_JEDNOTKY: 'BUDOVA_ROZESTAVENE_JEDNOTKY',
  },
  JEDNOTKA: {
    SKUPINA_BYTU: 'SKUPINA_BYTU',
    SKUPINA_NEBYTU: 'SKUPINA_NEBYTU',
    SKUPINA_OBOJE: 'SKUPINA_OBOJE',
    ROZESTAVENA_JEDNOTKA: 'ROZESTAVENA_JEDNOTKA',
    GARAZ_JEDNOTKA: 'GARAZ_JEDNOTKA',
    BYT: 'BYT',
    NEBYT: 'NEBYT',
    ATELIER: 'ATELIER',
    DILNA: 'DILNA',
  },
};

export const RealtyTypeRaw = {
  ZAHRADA: 'ZAHRADA',
  LESNI_POZEMEK: 'LESNI_POZEMEK',
  CHMELNICE: 'CHMELNICE',
  TRAVNATY_POROST: 'TRAVNATY_POROST',
  ZASTAVENA_PLOCHA: 'ZASTAVENA_PLOCHA',
  ORNA_PUDA: 'ORNA_PUDA',
  OVOCNY_SAD: 'OVOCNY_SAD',
  VODNI_PLOCHA: 'VODNI_PLOCHA',
  VINICE: 'VINICE',
  OSTATNI_PLOCHA: 'OSTATNI_PLOCHA',
  BUDOVA_S_POPISNYM: 'BUDOVA_S_POPISNYM',
  BUDOVA_S_EVIDENCNIM: 'BUDOVA_S_EVIDENCNIM',
  BUDOVA_BEZ_CISLA: 'BUDOVA_BEZ_CISLA',
  BUDOVA_ROZESTAVENA: 'BUDOVA_ROZESTAVENA',
  VODNI_DILO: 'VODNI_DILO',
  BUDOVA_ROZESTAVENE_JEDNOTKY: 'BUDOVA_ROZESTAVENE_JEDNOTKY',
  SKUPINA_BYTU: 'SKUPINA_BYTU',
  SKUPINA_NEBYTU: 'SKUPINA_NEBYTU',
  SKUPINA_OBOJE: 'SKUPINA_OBOJE',
  ROZESTAVENA_JEDNOTKA: 'ROZESTAVENA_JEDNOTKA',
  GARAZ_JEDNOTKA: 'GARAZ_JEDNOTKA',
  BYT: 'BYT',
  NEBYT: 'NEBYT',
  ATELIER: 'ATELIER',
  DILNA: 'DILNA',
  PRAVO_STAVBY: 'PRAVO_STAVBY',
  OTHER: 'OTHER',
};

export const pozemky = [RealtyTypeRaw.ZAHRADA,RealtyTypeRaw.LESNI_POZEMEK,RealtyTypeRaw.CHMELNICE,RealtyTypeRaw.TRAVNATY_POROST,
  RealtyTypeRaw.ZASTAVENA_PLOCHA,RealtyTypeRaw.ORNA_PUDA,RealtyTypeRaw.OVOCNY_SAD,RealtyTypeRaw.VODNI_PLOCHA,RealtyTypeRaw.VINICE,RealtyTypeRaw.OSTATNI_PLOCHA
]
export const stavby = [RealtyTypeRaw.BUDOVA_S_POPISNYM,RealtyTypeRaw.BUDOVA_S_EVIDENCNIM,RealtyTypeRaw.BUDOVA_BEZ_CISLA,RealtyTypeRaw.BUDOVA_ROZESTAVENA,
  RealtyTypeRaw.VODNI_DILO,RealtyTypeRaw.BUDOVA_ROZESTAVENE_JEDNOTKY
]
export const jednotky = [RealtyTypeRaw.SKUPINA_BYTU,RealtyTypeRaw.SKUPINA_NEBYTU,RealtyTypeRaw.SKUPINA_OBOJE,RealtyTypeRaw.ROZESTAVENA_JEDNOTKA,
  RealtyTypeRaw.GARAZ_JEDNOTKA,RealtyTypeRaw.BYT,RealtyTypeRaw.NEBYT,RealtyTypeRaw.ATELIER,RealtyTypeRaw.DILNA
]

export const OtherContractType = createItems({
  SIMILAR_RELATIONSHIP: 'Obdobný vztah',
  EMPLOYMENT_RELATIONSHIP: 'Pracovněprávní vztah',
  SERVICE_RELATIONSHIP: 'Služební poměr',
});

export const Visibility = createItems({
  REQUEST: 'Na žádost',
  SECRET: 'Tajné',
  PUBLIC: 'Veřejné',
});

export const VisibilityRaw = {
  REQUEST: 'REQUEST',
  SECRET: 'SECRET',
  PUBLIC: 'PUBLIC',
};

export const RequestState = createItems({
  NEW: 'Nová',
  ACCEPT: 'Schválená',
  REJECT: 'Zamítnutá',
});

export const RequestStateRaw = {
  NEW: 'NEW',
  ACCEPT: 'ACCEPT',
  REJECT: 'REJECT',
};

export const InitiativeStateRaw = {
  NEW: 'NEW',
  FORWARDED: 'FORWARDED',
  ACCEPT: 'ACCEPT',
  REPLY: 'REPLY',
  REJECT: 'REJECT',
};

export const InitiativeState = createItems({
  NEW: 'Nový',
  FORWARDED: 'Postoupen',
  ACCEPT: 'Vyřizuje se',
  REPLY: 'Vyřízen',
  REJECT: 'Zamítnutý',
});

export const StatementTypeRaw = {
  INGOING: 'INGOING',
  ONGOING: 'ONGOING',
  OUTGOING: 'OUTGOING',
  POINT3: 'POINT3',
  POINT4: 'POINT4',
  DEPUTYORSENATE: 'DEPUTYORSENATE',
};

export const StatementTypeGrid = createItems({
  INGOING: 'Vstupní oznámení',
  ONGOING: 'Průběžné oznámení',
  OUTGOING: 'Výstupní oznámení',
  POINT3: 'Oznámení podle Čl. II bodu 3 přechodného ustanovení zákona',
  POINT4: 'Oznámení podle Čl. II bodu 4 – příjmy za rok 2017',
  DEPUTYORSENATE:
    'Oznámení pro poslance a senátory, kteří složili slib do 31.8.2017 včetně',
});

export const StatementType = createItems({
  INGOING: 'Vstupní oznámení',
  ONGOING: 'Průběžné oznámení',
  OUTGOING: 'Výstupní oznámení',
  POINT3: 'Oznámení podle Čl. II bodu 3 přechodného ustanovení zákona',
  POINT4: 'Oznámení podle Čl. II bodu 4 – příjmy za rok 2017',
});

export const StatementTypeNoPt3 = createItems({
  INGOING: 'Vstupní oznámení',
  ONGOING: 'Průběžné oznámení',
  OUTGOING: 'Výstupní oznámení',
});

export const StatementTypeSenatorOnly = createItems({
  // INGOING: 'Vstupní oznámení',
  ONGOING_PROMISED: 'Průběžné oznámení – senátor zvolen do 31. 8. 2017',
  OUTGOING_PROMISED: 'Výstupní oznámení – senátor zvolen do 31. 8. 2017',
});

export const StatementTypeSenatorNoPoint3 = createItems({
  INGOING: 'Vstupní oznámení',
  ONGOING_PROMISED: 'Průběžné oznámení – senátor zvolen do 31. 8. 2017',
  ONGOING: 'Průběžné oznámení – senátor zvolen od 31. 8. 2017',
  OUTGOING_PROMISED: 'Výstupní oznámení – senátor zvolen do 31. 8. 2017',
  OUTGOING: 'Výstupní oznámení – senátor zvolen od 31. 8. 2017',
});

export const StatementTypeSenatorAndOthers = createItems({
  INGOING: 'Vstupní oznámení',
  ONGOING: 'Průběžné oznámení',
  OUTGOING: 'Výstupní oznámení',
  ONGOING_PROMISED: 'Průběžné oznámení – senátor zvolen do 31. 8. 2017',
  OUTGOING_PROMISED: 'Výstupní oznámení – senátor zvolen do 31. 8. 2017',
});

export const StatementTypeSenatorAndOthersWithPoint3 = createItems({
  POINT3: 'Oznámení podle Čl. II bodu 3 přechodného ustanovení zákona',
  POINT4: 'Oznámení podle Čl. II bodu 4 – příjmy za rok 2017',
  INGOING: 'Vstupní oznámení',
  ONGOING: 'Průběžné oznámení',
  OUTGOING: 'Výstupní oznámení',
  ONGOING_PROMISED: 'Průběžné oznámení – senátor zvolen do 31. 8. 2017',
  OUTGOING_PROMISED: 'Výstupní oznámení – senátor zvolen do 31. 8. 2017',
});

export const StatementTypeSenatorWithPoint3 = createItems({
  POINT3: 'Oznámení podle Čl. II bodu 3 přechodného ustanovení zákona',
  POINT4: 'Oznámení podle Čl. II bodu 4 – příjmy za rok 2017',
  INGOING: 'Vstupní oznámení',
  ONGOING_PROMISED: 'Průběžné oznámení – senátor zvolen do 31. 8. 2017',
  ONGOING: 'Průběžné oznámení – senátor zvolen od 31. 8. 2017',
  OUTGOING_PROMISED: 'Výstupní oznámení – senátor zvolen do 31. 8. 2017',
  OUTGOING: 'Výstupní oznámení – senátor zvolen od 31. 8. 2017',
});

export const StatementTypeDeputy = createItems({
  INGOING: 'Vstupní oznámení',
  ONGOING: 'Průběžné oznámení',
  OUTGOING: 'Výstupní oznámení',
});

export const StatementTypeDeputyOld = createItems({
  INGOING: 'Vstupní oznámení',
  ONGOING: 'Průběžné oznámení',
  OUTGOING: 'Výstupní oznámení',
  POINT3: 'Oznámení podle Čl. II bodu 3 přechodného ustanovení zákona',
});

export const StatementTypeDeputySenatorAndOthers = createItems({
  INGOING: 'Vstupní oznámení',
  ONGOING: 'Průběžné oznámení',
  OUTGOING: 'Výstupní oznámení',
  POINT3: 'Oznámení podle Čl. II bodu 3 přechodného ustanovení zákona',
  POINT4: 'Oznámení podle Čl. II bodu 4 – příjmy za rok 2017',
});

export const Source = {
  PERSON: 'PERSON',
  LEGAL_PERSON: 'LEGAL_PERSON',
  OTHER: 'OTHER',
};

export const InitiativeResult = createItems({
  RESULT_E:
    'Rozhodnuto o přestupku podle § 23 odst. 1 písm. e) zákona o střetu zájmů',
  RESULT_F:
    'Rozhodnuto o přestupku podle § 23 odst. 1 písm. f) zákona o střetu zájmů',
  RESULT_B:
    'Rozhodnuto o přestupku podle § 23 odst. 2 písm. b) zákona o střetu zájmů',
  STOPPED: 'Řízení bylo zastaveno',
  OTHER_RESULT: 'Skončeno jiným způsobem',
});

export const StatementState = createItems({
  NEW: 'Rozpracované', //'Nové',
  ACCEPT: 'Odeslané', //'Přijaté',
  INCOMPLETE: 'Neúplné',
  WRONG: 'Odeslané', //'Chybné',
});

export const StatementStateInternal = createItems({
  NEW: 'Rozpracované', //'Nové',
  ACCEPT: 'Odeslané', //'Přijaté',
  INCOMPLETE: 'Neúplné',
  WRONG: 'Chybné', //'Chybné',
});

export const StatementStateFilterItems = createItems({
  Rozpracované: "Rozpracované",
  Přijaté: "Odeslané",
  Neúplné: "Neúplné",
  Chybné: "Chybné"
});

export const StatementStateRaw = {
  NEW: 'NEW',
  ACCEPT: 'ACCEPT',
  INCOMPLETE: 'INCOMPLETE',
  WRONG: 'WRONG',
};

export const StatementFileType = {
  STATEMENT: 'STATEMENT',
  REALITIES: 'REALITIES'
};

export const StatementFileVisibility = {
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE'
};

export const StatementAppealsFilterType = {
  NONE: 'Ne',
  MISSING: 'Ano - opožděné oznámení',
  INCOMPLETE: 'Ano - neúplné oznámení',
};

export const StatementAppealsFilterEnum = createItems(StatementAppealsFilterType);

export const EmailTemplatesType = createItems({
  APPEAL_CREATE: "Výzva veřejnému funkcionáři",
  CREDENTIALS_CREATE: "Vytvoření přístupových údajů",
  STATEMENT_ACCEPTED: "Oznámení přijato",
  INGOING_STATEMENT_REMINDER: "Připomenutí vstupního oznámení",
  OUTGOING_STATEMENT_REMINDER: "Připomenutí výstupního oznámení",
  ONGOING_STATEMENT_REMINDER: "Připomenutí průběžného oznámení",
  ONGOING_STATEMENT_REMINDER_NO_SCHEDULED: "Připomenutí průběžného oznámení (bez termínu)",
  REQUEST_ACCEPT: "Žádost schválena",
  REQUEST_REJECT: "Žádost zamítnuta",
  REQUEST_CREATE: "Vytvoření žádosti",
  INITIATIVE_ACCEPT: "Podnět schválen",
  INITIATIVE_REJECT: "Podnět zamítnut",
  INITIATIVE_CREATE: "Vytvoření podnětu",
  INITIATIVE_TO_ORGANIZATION: "Podnět předán organizaci",
  INVESTIGATION_FAQ: "FAQ k šetření",
});

export const DocumentTemplatesType = createItems({
  WORKING_POSITION_HANDOVER_PROTOCOL_IN: "Předávací protokol - vstupní oznámení",
  WORKING_POSITION_HANDOVER_PROTOCOL_OUT: "Předávací protokol - výstupní oznámení",
  INGOING_FORWARD: "Postoupení vstupního oznámení",
  OUTGOING_FORWARD: "Postoupení výstupního oznámení",
  ONGOING_FORWARD: "Postoupení průběžného oznámení",
  WRONG_OR_INCOMPLETE_FORWARD: "Postoupení nesprávného nebo neúplného oznámení",
});

export const AppealsType = createItems({
  INCOMPLETE: 'Neúplné oznámení',
  MISSING: 'Chybějící oznámení'
});

export const InspectionType = {
  INGOING_STATEMENT: "INGOING_STATEMENT",
  ONGOING_STATEMENT: "ONGOING_STATEMENT",
  OUTGOING_STATEMENT: "OUTGOING_STATEMENT",
  CONTENT: "CONTENT",
  OTHER: "OTHER"
};

export const InspectionTypeEnum = createItems({
  INGOING_STATEMENT: "Včasnost vstupního oznámení",
  ONGOING_STATEMENT: "Včasnost průběžného oznámení",
  OUTGOING_STATEMENT: "Včasnost výstupního oznámení",
  CONTENT: "Obsahová",
  OTHER: "Jiná"
})

export const InspectionResult = {
  OK: 'OK',
  PROBLEM: 'PROBLEM',
}

export const InspectionResultEnum = createItems({
  OK: 'V pořádku',
  PROBLEM: 'Kontrola s problémy',
})

export const InspectionResultSymbol = {
  OK: '✓',
  PROBLEM: 'X',
}

export const WorkingPositionHandoverProtocolType = {
  INGOING_STATEMENT: 'INGOING_STATEMENT',
  OUTGOING_STATEMENT: 'OUTGOING_STATEMENT',
}